// extracted by mini-css-extract-plugin
export default {"container":"widget_container__m8mXi","icon":"widget_icon__xRxn0","title":"widget_title__fm2WR","value":"widget_value__CcSvy"};